import { render } from "./Notificacoes.vue?vue&type=template&id=972dd280"
import script from "./Notificacoes.vue?vue&type=script&lang=ts"
export * from "./Notificacoes.vue?vue&type=script&lang=ts"
script.render = render

export default script